import { api } from './client';
import type { PaymentOrderResponse, PaymentResponse, Uuid } from '../types/api';

export async function createPaymentOrder(invoiceId: Uuid): Promise<PaymentOrderResponse> {
  const { data } = await api.post<PaymentOrderResponse>('/payments/orders', { invoiceId });
  return data;
}

export interface VerifyPaymentPayload {
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}

export async function verifyPayment(payload: VerifyPaymentPayload): Promise<PaymentResponse> {
  const { data } = await api.post<PaymentResponse>('/payments/verify', payload);
  return data;
}
